import sanityTest from './sanitytest';

export default {
  sanityTest,
};
